import { render, staticRenderFns } from "./DebugPermissions.vue?vue&type=template&id=c099f33c&scoped=true&"
import script from "./DebugPermissions.vue?vue&type=script&lang=js&"
export * from "./DebugPermissions.vue?vue&type=script&lang=js&"
import style0 from "./DebugPermissions.vue?vue&type=style&index=0&id=c099f33c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c099f33c",
  null
  
)

export default component.exports